"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const _2 = require(".");
/**
 * Represents a cancellable token linked to a cancellation source. This token
 * will transition to the cancelled state when the source is cancelled.
 */
class CancellationToken {
    /**
     * Creates a cancellation token which cancels when `future` resolves.
     * @param future
     */
    constructor(future) {
        this._cancelled = false;
        /**
         * Returns a promise which resolves when the token is cancelled or throws
         * after the specified timeout in milliseconds.
         * @param timeoutMs milliseconds after which to throw.
         * @throws if the token does not cancel after timeoutMs milliseconds
         */
        this.waitForCancellation = async (timeoutMs) => {
            const result = await Promise.race([_1.Task.delay(timeoutMs), this.waitHandle]);
            if (result !== this) {
                throw new _2.TimeoutError();
            }
        };
        this._future = future;
        this.waitHandle.then(() => this._cancelled = true);
    }
    /**
     * Creates a promise which resolves when the token is cancelled.
     * @returns Promise
     */
    async _waitHandle() {
        await this._future.promise;
        return this;
    }
    /**
     * Returns true if the cancellation token is cancelled.
     */
    get isCancellationRequested() {
        return this._cancelled;
    }
    /**
     * Returns a promise which resolves when the token is cancelled.
     */
    get waitHandle() {
        return this._waitHandle();
    }
}
exports.default = CancellationToken;
//# sourceMappingURL=cancellationToken.js.map